"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var PopupTitle_1 = __importDefault(require("../PopupTitle"));
var PopupContent_1 = __importDefault(require("../PopupContent"));
var PopupActions_1 = __importDefault(require("../PopupActions"));
var ButtonOutlined_1 = __importDefault(require("../Button/ButtonOutlined"));
var TooltipDialogSC_1 = __importDefault(require("./styles/TooltipDialogSC"));
var factoryTooltip_1 = __importDefault(require("./utils/factoryTooltip"));
var RenderDialogTooltip = function (props) {
    var title = props.title, content = props.content, actions = props.actions, onActions = props.onActions, onClose = props.onClose;
    var firstAction = actions[0];
    var onFirstAction = onActions[0];
    return (react_1.default.createElement("div", { className: "_ndsTooltip__content" },
        react_1.default.createElement(PopupTitle_1.default, { onClose: onClose }, title),
        react_1.default.createElement(PopupContent_1.default, null, content),
        firstAction && (react_1.default.createElement(PopupActions_1.default, null,
            react_1.default.createElement(ButtonOutlined_1.default, { onClick: onFirstAction, type: "button", compact: true }, firstAction)))));
};
var TooltipDialog = function (props) {
    var title = props.title, content = props.content, actions = props.actions, onActions = props.onActions, onClose = props.onClose, forwardedRef = props.forwardedRef, _a = props.rootStyle, rootStyle = _a === void 0 ? {} : _a, placement = props.placement, _b = props.arrowProps, arrowProps = _b === void 0 ? {} : _b, classNameProp = props.className;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TooltipDialogSC_1.default, { ref: forwardedRef, style: rootStyle, "data-placement": placement, className: clsx_1.default('_ndsTooltip', classNameProp) },
            react_1.default.createElement(RenderDialogTooltip, { title: title, content: content, onClose: onClose, actions: actions, onActions: onActions }),
            react_1.default.createElement("div", { ref: arrowProps.ref, style: arrowProps.style, className: "_ndsTooltip__arrow" }))));
};
exports.default = factoryTooltip_1.default(TooltipDialog, 'dialog');
//# sourceMappingURL=TooltipDialog.js.map